<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchReport" class="p-button-raised" label="Search"
                  icon="pi pi-search" />
              </div>
            </div>
          </form>

        <DataTable :value="transformedData" :paginator="true" :rows="10" 
                   :rowsPerPageOptions="[10, 20, 50]" class="p-datatable-responsive p-datatable-gridlines">
          <Column field="customerType" header="Customer Type" :sortable="true"></Column>
          
          <!-- Dynamic Date Columns -->
          <Column v-for="date in uniqueDates" :key="date" :header="formatDate(date)">
            <template #body="slotProps">
              <div v-if="slotProps.data[date]">
                {{ slotProps.data[date].salesCount }} orders<br>
                Rs. {{ slotProps.data[date].totalSales.toFixed(2) }}
              </div>
              <div v-else>
                0 orders<br>
                Rs. 0.00
              </div>
            </template>
            <template #footer>
              <div>
                {{ getDateTotal(date).count }} orders<br>
                Rs. {{ getDateTotal(date).amount.toFixed(2) }}
              </div>
            </template>
          </Column>
          
          <Column header="Total" headerStyle="font-weight: bold">
            <template #body="slotProps">
              <div>
                {{ slotProps.data.totalOrders }} orders<br>
                Rs. {{ slotProps.data.totalAmount.toFixed(2) }}
              </div>
            </template>
            <template #footer>
              <div style="font-weight: bold">
                {{ grandTotalOrders }} orders<br>
                Rs. {{ grandTotalAmount.toFixed(2) }}
              </div>
            </template>
          </Column>
          
          <template #empty>No records found. Please search with date range.</template>
        </DataTable>
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import $ from 'jquery'

export default {
  name: 'CustomerWiseSalesReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      loading: false,
      salesData: [],
      englishDateEnabled: true,
      uniqueDates: []
    }
  },
  computed: {
    transformedData() {
      if (!this.salesData.length) return []
      const grouped = {}
      this.salesData.forEach(item => {
        if (!grouped[item.customerType]) {
          grouped[item.customerType] = {
            customerType: item.customerType,
            totalOrders: 0,
            totalAmount: 0
          }
        }
        grouped[item.customerType][item.date] = {
          salesCount: item.salesCount,
          totalSales: item.totalSales
        }
        grouped[item.customerType].totalOrders += item.salesCount
        grouped[item.customerType].totalAmount += item.totalSales
      })
      return Object.values(grouped)
    },
    grandTotalOrders() {
      return this.salesData.reduce((sum, item) => sum + item.salesCount, 0)
    },
    grandTotalAmount() {
      return this.salesData.reduce((sum, item) => sum + item.totalSales, 0)
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.initializeDates()
  },
  methods: {
    async searchReport() {
      this.loading = true
      try {
        const data = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        const resp = await this.$store.dispatch('loadCustomerWiseSalesCountLists', data)
        if (resp.data.data.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
        } else {
          this.salesData = resp.data.data
          this.extractUniqueDates()
        //  this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load data',
          life: 3000
        })
      } finally {
        this.loading = false
      }
    },
    extractUniqueDates() {
      const dates = new Set()
      this.salesData.forEach(item => dates.add(item.date))
      this.uniqueDates = Array.from(dates).sort()
    },
    getDateTotal(date) {
      const result = { count: 0, amount: 0 }
      this.salesData.filter(item => item.date === date).forEach(item => {
        result.count += item.salesCount
        result.amount += item.totalSales
      })
      return result
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    initializeDates() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    setEnglishDate() {
      const today = new Date()
      this.fromDate = today.toISOString().slice(0, 10)
      this.toDate = today.toISOString().slice(0, 10)
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Button,
    InputMask
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">

.p-datatable .p-column-header-content {
  white-space: normal !important;
  text-align: center;
}
.p-datatable td {
  text-align: center;
}
.p-datatable-footer td {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// CustomerWiseSalesCount.vue?e94ae34c